module.exports = __webpack_public_path__ + "img/BAU_Partners_16.bb69555b.jpg";